import React from 'react';
import Vision from '../a_propos/Vision/Vision';
import NosServices from '../a_propos/NosServices/NosServices';
import Valeurs from '../a_propos/Valeurs/Valeurs';
import Button from '../../components/Button/Button';
function NavigationApropos() {
  return (
    <div className="app-container">
        <Vision />
        <Valeurs />
        <Button />
        <NosServices />
  </div>
  );

}
export default NavigationApropos